import { Version } from '../../../../../models/version';
import { Page } from '../../../../../models/page';
import { FormValues } from './types';

const getHtmlFromVersionAndLocale = (
  selectedVersion: Version,
  selectedLanguage: string
): string => {
  const content = selectedVersion.contents.find(
    ({ language }) => language == selectedLanguage
  );
  return content ? content.html : '';
};

const findName = (version: Version, locale: string) =>
  version.contents.find(({ language }) => language === locale)?.name;

export const getInitialValues = (
  page: Page,
  selectedVersion: Version,
  selectedLanguage: string
): FormValues => ({
  id: selectedVersion.id,
  name: findName(selectedVersion, selectedLanguage),
  liveDate: new Date(selectedVersion.liveDate),
  slug: page.slug,
  groupName: page.groupName,
  rawText: getHtmlFromVersionAndLocale(selectedVersion, selectedLanguage),
  locale: selectedLanguage,
  hasEmbedded: selectedVersion.hasEmbedded,
  nestedCounterList: selectedVersion.nestedCounterList,
  hideToc: selectedVersion.hideToc,
});
